import {
  Easing,
  EffectConfig,
  EffectFourDirections,
  EffectParams,
  SchemaGroup,
} from '../types';
import {
  allowReplay,
  delay,
  duration,
  easingExcludingBackOut,
  directionFourSides,
} from './baseParams';

export interface ShuttersIn extends EffectParams {
  direction: EffectFourDirections; // 8 possible directions, but exposing only 4
  shutters?: number;
  staggered: number;
  easing?: Easing;
}

const name = 'ShuttersIn';
const groups: SchemaGroup[] = ['entrance', 'animation'];

export const config: EffectConfig<ShuttersIn> = {
  name,
  groups,
  schema: {
    delay: { ...delay },
    allowReplay: { ...allowReplay },
    duration: { ...duration, default: 1200 },
    shutters: { type: 'number', min: 2, max: 20, default: 12, step: 1 },
    direction: { ...directionFourSides },
    staggered: { type: 'boolean', default: true },
  },
  hide: true,
} as const;

export const responsiveConfig: EffectConfig<ShuttersIn> = {
  name,
  groups,
  schema: {
    delay: { ...delay },
    allowReplay: { ...allowReplay },
    duration: { ...duration, default: 1200 },
    shutters: { type: 'number', min: 2, max: 20, default: 12, step: 1 },
    direction: { ...directionFourSides },
    staggered: { type: 'boolean', default: true },
    easing: { ...easingExcludingBackOut, default: 'cubicInOut' },
  },
  hide: true,
} as const;
